import { createFileRoute } from '@tanstack/react-router'

import { BookingDetailPage } from '@/components/booking-detail/booking-detail-page'

export const Route = createFileRoute('/_authenticated/_layout/booking/$bookingRef')({
  component: RouteComponent,
})

function RouteComponent() {
  const { bookingRef } = Route.useParams()
  return <BookingDetailPage bookingRef={bookingRef} />
}
